<mat-card class="slidecontent" >
  <div class="headcontent">
    <div class="pophead">
      <h3>Create Permission</h3>
  
      <mat-icon (click)="close()" class="close">close</mat-icon>
  
  </div>
</div>
  <div class="dialog_content">
  
      <div [formGroup]="createPermissionform">
  
          <div fxLayout="row" fxLayoutAlign="start start">
              <mat-form-field appearance="legacy" fxFlex>
                  <mat-label>Name</mat-label>                  
                  <input matInput maxlength="30" placeholder="Permission Name" formControlName="permissionName" #permissionName>
                  <mat-error>
                    This field is required
                  </mat-error>
              </mat-form-field>
          </div>
  
          <div fxLayout="row" fxLayoutAlign="start start">
              <mat-form-field class="choose" appearance="legacy" fxFlex>
                  <mat-label>Description</mat-label>
                  <input matInput maxlength="100" placeholer="Permission Description" formControlName="permissionDescription">
                  
                  <mat-error>
                    This field is required
                      
                  </mat-error>
              </mat-form-field>
          </div>
  
          <div class="mb-15" fxLayout="column" fxLayoutAlign="start start">
            <div class="label">Permissions Applied</div>
            <div class="peropt" fxLayout="row" fxLayoutAlign="space-between center" >
              <mat-checkbox color="primary" formControlName="permissionAdd">Add</mat-checkbox>
              <mat-checkbox color="primary" formControlName="permissionEdit">Edit</mat-checkbox>
              <mat-checkbox color="primary" formControlName="permissionDelete">Delete</mat-checkbox>
            </div>
          </div> 
                   
          <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field>
              <mat-select placeholder = "Module List"  formControlName="moduleSelected"
                 [(ngModel)]="moduleSelected" name = "moduleSelected">
                 <mat-option *ngFor = "let module of ModuleList" 
                    [value] = "module.moduleID">
                    {{module.moduleName}}
                 </mat-option>
              </mat-select>
           </mat-form-field>
           </div>
          
  
  
          </div>
  </div>
  

  <div class="actionBtn">
  
      <button mat-flat-button class="cancel" (click)="close()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" [disabled]="!createPermissionform.valid"
      (click)="createPermission(createPermissionform.value)" color="primary">Create</button>
  </div>

</mat-card>


<div class="overlay" (click)="close()" ></div>
  
